export enum DocumentScanStatusType {
  Started,
  RequestFailed,
  Finished
}
